import { useEffect, useState, useRef } from 'react'
import { withTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useApp } from '@/lib/hooks'
import Button from '@/ui/Button'
import { ReactComponent as BergLogo } from '@/assets/berg-regions.svg'

import useCheckout from '../Checkout/hooks/useCheckout'
import { IntroAction, IntroBackground, IntroLogo, IntroText, IntroWrapper, IntroPoweredBy } from './Intro.styles'

const Intro = ({ t }) => {
  const { reset } = useCheckout()
  const { data: appSettings } = useApp()
  const { logo, backgroundVideo, backgroundMedia } = appSettings || {}
  const [clickCount, setClickCount] = useState(0)
  const timeoutRef = useRef(null)

  const navigate = useNavigate()

  useEffect(() => {
    reset()
  }, [])

  const handleLogoClick = (e) => {
    e.stopPropagation()

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    const newCount = clickCount + 1
    setClickCount(newCount)

    if (newCount === 5) {
      if (window.BtDevice && window.BtDevice.clearSettings) {
        window.BtDevice.clearSettings()
      }
      setClickCount(0)
    } else {
      timeoutRef.current = setTimeout(() => {
        setClickCount(0)
      }, 5000)
    }
  }

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [])

  return (
    <IntroWrapper onClick={() => navigate('/menu')}>
      {backgroundVideo ? (
        <IntroBackground>
          <video src={backgroundVideo.files.find(o => o.quality === 'hd').link} muted loop autoPlay playsInline />
        </IntroBackground>
      ) : (
        <IntroBackground>
          <img src={backgroundMedia.url} alt="..." />
        </IntroBackground>
      )}
      {logo && <IntroLogo src={logo.url}></IntroLogo>}
      <IntroText>{t('orderHere')}</IntroText>
      <IntroAction>
        <Button size="xl">{t('makeOrder')}</Button>
      </IntroAction>
      <IntroPoweredBy onClick={handleLogoClick}>
        <BergLogo />
      </IntroPoweredBy>
    </IntroWrapper>
  )
}

export default withTranslation()(Intro)
